import React from 'react'
import Filter from '../Components/ProductPage/Filter'
// import Pagination from '../Components/ProductPage/Pagination'
import { ProductsList } from '../Components/ProductPage/Productlist'
import Sort from '../Components/ProductPage/Sort'

export default function ProductPage() {
  
  return (
    <div style={{display:"flex",
    margin:"0",
    padding:"0",
    }}>
      <div style={{
        width:"18%"
      }}><Filter/></div>
      <div style={{
        width:"82%"
      }}>
      <div style={{
        marginLeft:"20px",
        marginTop:"20px",
      }}><Sort/></div>
      <div><ProductsList/></div>
      </div>
      {/* <div><Pagination/></div> */}
    </div>
  )
}
